function add_ingredient_row() {
    var $container = $('.ingredient-container');
    var $cloneable = $container.find('.cloneable');

    //Clone cloneable measurement row and append to container
    var $row = $cloneable.clone();
    $row.removeClass('cloneable').addClass('visible');
    $row.find('input[disabled], select[disabled]').removeAttr('disabled');
    $row.find('.no-touchy').removeClass('no-touchy');

    //Disable wastage/unit when cloning new row
    $row.find('select[name="ingredient_wastage_id[]"]').attr('disabled', 'disabled');
    $row.find('select[name="ingredient_unit[]"]').attr('disabled', 'disabled');

    $row.appendTo($container);

    $('.ingredient-hint').hide();

    init_selects();

    return $row;
}

$(function() {

    $body.on('click', '#add-ingredient-row', function(e) {
        e.preventDefault();
        add_ingredient_row();
    });

    $body.on('click', '#add-ingredient-row-5', function(e) {
        e.preventDefault();

        for(var i = 0; i < 5; i++) {
            add_ingredient_row();
        }
    });

    $body.on('click', '#create-ingredient-row', function(e) {
        e.preventDefault();

        //If modal already exists, simply show it
        if($('.ingredient-popup').length) {
            $('.custom-modal__overlay, .ingredient-popup').fadeIn(300);
            scroll_to_pos(0);

        } else {

            //Get and append the ingredient modal to the page
            ajax_call('get', '/admin/ingredients/add_popup', {}, function(resp) {

                if(resp.response) {

                    //Add modal to DOM
                    $('body').append(resp.body);

                    //Init select plugin
                    init_selects();

                    //Show form save buttons
                    $('button[type="submit"]').css('visibility', 'visible');

                    //Trigger unit change
                    $('#popup-ingredient-form #unit').trigger('change');

                    //Show modal
                    $('.custom-modal__overlay, .ingredient-popup').fadeIn(300);
                    scroll_to_pos(0);
                    init_basic_tooltips();
                }

            });
        }

    });

    $body.on('click', '.edit-recipe-ing, .edit-stocktake-ing', function(e) {
        e.preventDefault();
        var id = $(this).data('id');

        //Get and append the ingredient modal to the page
        ajax_call('get', '/admin/ingredients/edit_popup/' + id, {}, function(resp) {

            if(resp.response) {

                //Delete existing modal
                $('.ingredient-edit-popup').remove();

                //Add modal to DOM
                $('body').append(resp.body);

                //Init select plugin
                init_selects();

                //Show form save buttons
                $('button[type="submit"]').css('visibility', 'visible');

                //Trigger unit change
                $('#popup-edit-ingredient-form #unit').trigger('change');

                //Show modal
                $('.custom-modal__overlay, .ingredient-edit-popup').fadeIn(300);
                scroll_to_pos(0);
                init_basic_tooltips();
                init_popovers();
            }

        });

    });

    //Change ingredient selected on Recipe form
    $('#edit-recipe-form').on('change', 'select[name="ingredient_id_select[]"]', function(e) {
        var $row = $(this).closest('.row');
        var $ing_type = $row.find('select[name="ingredient_wastage_id[]"]');
        var $ing_unit = $row.find('select[name="ingredient_unit[]"]');
        var ing_type_prev = $ing_type.attr('data-prev-value');
        var ing_unit_prev = $ing_unit.attr('data-prev-value');

        //Set data
        var ing_id = $(this).val();
        var $selected_ing = $(this).find('option:selected');

        //Disable ing type and unit selects
        $ing_type.attr('disabled', 'disabled').trigger('chosen:updated');
        $ing_unit.attr('disabled', 'disabled').trigger('chosen:updated');

        if($selected_ing.data('context') === 'ingredient') {

            //Set id to hidden field
            $row.find('input[name="ingredient_id[]"]').val(ing_id);
            $row.find('input[name="ingredient_id_recipe[]"]').val('-1');

            //Set id to edit button (if has one)
            $row.find('.edit-recipe-ing').data('id', ing_id).show();

            //Get ing/rcp fields
            var $ing_fields = $row.find('.toggle-type[data-context="ingredient"]');
            var $rcp_fields = $row.find('.toggle-type[data-context="recipe"]');

            //Set ing fields to enabled
            $ing_fields.find('input, select, textarea').removeAttr('disabled');

            //Set rcp fields to disabled
            $rcp_fields.find('input, select, textarea').attr('disabled', 'disabled');

            //Show/hide them
            $ing_fields.show();
            $rcp_fields.hide();

            //Get wastages for selected ingredient
            get_wastages_for_ingredient(ing_id, function(resp) {

                //If successful...
                if(resp.response) {

                    //Replace the wastage select with our new one
                    $ing_type.parent().html(resp.content);

                } else {
                    alert(resp.message);
                }

                //Need to reinit selects when both are done
                init_selects();

            }, ing_type_prev);

            //Get units for selected ingredient
            get_units_for_ingredient(ing_id, function(resp) {

                //If successful...
                if(resp.response) {

                    //Replace the unit select with our new one
                    $ing_unit.parent().html(resp.content);

                } else {
                    alert(resp.message);
                }

                //Need to reinit selects when both are done
                init_selects();

            }, ing_unit_prev);

        } else if($selected_ing.data('context') === 'recipe')  {

            //Set id to hidden field
            $row.find('input[name="ingredient_id_recipe[]"]').val(ing_id);
            $row.find('input[name="ingredient_id[]"]').val('-1');

            //Hide edit button for this one
            $row.find('.edit-recipe-ing').data('id', '').hide();

            //Get ing/rcp fields
            var $ing_fields = $row.find('.toggle-type[data-context="ingredient"]');
            var $rcp_fields = $row.find('.toggle-type[data-context="recipe"]');

            //Set ing fields to disabled
            $ing_fields.find('input, select, textarea').attr('disabled', 'disabled');

            //Set rcp fields to enabled
            $rcp_fields.find('input, select, textarea').removeAttr('disabled');

            //Show/hide them
            $ing_fields.hide();
            $rcp_fields.show();

            //Get units for selected recipe
            get_units_for_recipe(ing_id, function(resp) {

                //If successful...
                if(resp.response) {

                    //Replace the unit select with our new one
                    $ing_unit.parent().html(resp.content);

                } else {
                    alert(resp.message);
                }

                //Reset wastages dropdown (remove all options)
                $ing_type.find('option[value!="-1"]').remove();
                $ing_type.val('-1').removeAttr('disabled').trigger('chosen:updated');

                //Need to reinit selects when both are done
                init_selects();

            }, 'ingredient_unit[]');
        }

    });

    //Change ingredient quantity/unit on recipe form
    $('#edit-recipe-form').on('change', 'select[name="ingredient_id_select[]"], select[name="ingredient_wastage_id[]"], input[name="ingredient_quantity[]"], select[name="ingredient_unit[]"]', function(e) {
        var $row = $(this).closest('.recipe-ingredient-row');
        var $ingredients = $row.find('select[name="ingredient_id_select[]"] option');
        var $wastages = $row.find('select[name="ingredient_wastage_id[]"] option');
        var $units = $row.find('select[name="ingredient_unit[]"] option');
        var $selected_ing = [];
        var $selected_wastage = [];
        var $selected_unit = [];

        //Get selected ingredient
        $.each($ingredients, function(i, v) {
            if($(this).prop('selected')) {
                $selected_ing = $(this);
            }
        });

        //Get selected wastage
        $.each($wastages, function(i, v) {
            if($(this).prop('selected')) {
                $selected_wastage = $(this);
            }
        });

        //Get selected units
        $.each($units, function(i, v) {
            if($(this).prop('selected')) {
                $selected_unit = $(this);
            }
        });

        //If we have selected an ingredient...
        if($selected_ing.length > 0) {

            var source_quantity = $selected_ing.data('quantity');
            var source_unit = $selected_ing.data('unit');
            var source_price = $selected_wastage.data('price') ? $selected_wastage.data('price') : $selected_ing.data('price');
            var $target_quantity = $row.find('input[name="ingredient_quantity[]"]');
            var target_quantity = $target_quantity.val();

            //Convert any "custom" unit metrics into their proper values for calcing
            var custom_quantity = $selected_unit.data('custom-quantity') ? parseFloat($selected_unit.data('custom-quantity')) : 1;
            var new_quantity = (parseFloat($selected_unit.data('quantity')) * parseFloat(target_quantity)) / custom_quantity;
            var new_unit = $selected_unit.data('unit');

            var $price = $row.find('.ingredient-price');

            //Ensure all needed fields are here before calculating price
            if(source_quantity && source_unit && source_price && Number.isFinite(new_quantity) && new_unit) {

                //Set loading on price
                $price.html("...");

                //Load in the ingredient wastages
                ajax_call('get', '/admin/get_price/' + source_quantity + '/' + source_unit + '/' + new_quantity + '/' + new_unit + '/' + source_price, {}, function(resp) {

                    //If successful...
                    if(resp.response) {

                        //Replace the wastage select with our new one
                        $price.html(resp.content);

                    } else {
                        alert(resp.message);
                    }
                });
            } else {
                console.log('At least one value missing - cannot calc price.');
            }

        }

    });


});
